module.exports = __webpack_public_path__ + "img/63.08f04ac1.jpg";